import axios from "axios";
import config from "../constants/config";

export default {
  methods: {
    async CreateVmsDevice(body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.VMS.CREATE_VMS}`,
        body
      );

      return res.data;
    },

    async ShowVmsDevices() {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.VMS.SHOW_VMS}`
      );

      return res.data;
    },

    async UpdateVmsDevice(payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.VMS.UPDATE_VMS}`,
        payload
      );

      return res.data;
    },

    async DeleteVmsDevice(payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.VMS.DELETE_VMS}`,
        payload
      );

      return res.data;
    },
  },
};
